export const API_PATH = process.env.REACT_APP_API_PATH || 'http://localhost:8080/api'
